var NPSContext = (function($) {
    var active = null;

    function extract(el) {
        var html = $(el).html();
        return $(html);
    }

    function menu(opts) {
        var el = document.getElementById(opts.el),
            $el = extract(el), qc;

        this.callback = opts.owner || window;
        this.context = opts.context || this;
        this.source = $el;
        this.stayontop = !!$el.data('stayontop');
        this.options = opts || {};
        this.actions = [];

        this.width = $el.attr('width');

        this.queryContext = opts.queryContext;
        if (!this.queryContext) {
            qc = $el.attr('queryContext') || "queryContextItem";
            if (this.callback[qc])
                this.queryContext = _.bind(this.callback[qc], this.context);
        }
        this.popup = null;
    }

    menu.prototype.show = function show(opts) {
        var localWidth, oPopup, $pop, renders, html, w, l, h, t, mw, mh;

        if (active) {
            active.hide();
            active=null;
        }


        opts = opts || {};
        localWidth = opts.width || this.width;


        oPopup = document.createElement("div");
        document.body.appendChild(oPopup);
        oPopup.style.position='absolute';
        oPopup.className = 'contexted';
        if (opts.className) {
            oPopup.className+= ' '+opts.className;
        }

        renders = this.populatePopup(opts);
        if (!renders.length) return;

        html = "<div class='"+this.source.attr('class')+" contextContainer'>"+
                _.pluck(renders, 'html').join('')+
            "</div>";

        oPopup.innerHTML = html;
        oPopup.ownedBy = this.source;

        $pop = $(oPopup);

        $pop.css({
            zIndex: 20000,
            display: 'block',
            width: localWidth
        });
        $pop.on('click', '.ctAction', _.bind(this.triggerAction, this));
        $pop.on('click mousedown', function() {
            return false;
        });

        if (opts.element) {
            var pos = _.extend({
                of: opts.element,
                my: 'left top',
                at: 'left bottom',
                collision: 'fit fit'
            }, opts.position);
            $pop.position(pos);
        } else {
            t = opts.position.top; h = $pop.height(); mh = $('body').scrollTop() + document.body.clientHeight;
            l = opts.position.left; w = $pop.width();

            if ((l+w)>document.body.offsetWidth)
                l = document.body.offsetWidth-w;

            if ((t+h)>mh)
                t = mh-h;

            $pop.css({
                left: l,
                top: t
            });
        }

        this.unveiled=true;

        active = this;
        this.popup = $pop;

        if (!opts.shielded)
            $('body').trigger('quake');

        $('body').one('click tremor quake', _.bind(this.hide, this));

        if (this.options.on && this.options.on.show) {
            this.options.on.show.call(this);
        }
    };
    menu.prototype.hide = function hide() {
        if (this.popup) {
            this.popup.remove();
        }
        this.popup = null;

        if (this.options.on && this.options.on.hide) {
            this.options.on.hide.call(this);
        }
    };
    menu.prototype.inplace = function inplace() {


    };
    menu.prototype.triggerAction = function triggerAction(e) {
        var $target = $(e.currentTarget),
            action = $target.data('action'),
            todo = action.callback || action.action,
            ctx = this.callback,
            opts = this.options,
            f;

        if (_.isFunction(opts.actions)) {
            opts.actions.call(this, todo, action.options);
        } else {
            f = opts.actions && opts.actions[todo];
            f = f || ctx[todo];

            if (f) {
                f.call(this.context || this, action.options);
            }
        }

        if (this.stayontop) {
            e.stopPropagation();
        } else {
            this.hide();
        }
    };

    menu.prototype.populatePopup = function populatePopup(opts) {
        var items, nodes, m = this,
            sources = [this.source];

        opts = opts || {};

        if (opts.more) {
            sources.push(extract(opts.more));
        }

        nodes = _(sources).chain()
            .map(function(source) {
                return [].slice.call(source.get(0).children);
            })
            .flatten()
            .value();

        items = this.convertSources(nodes);
        if (opts.replace) {
            _.each(items, function(item) {
                if (item.type !== 'group') return;
                if (!opts.replace[item.group]) return;

                var src = opts.replace[item.group].src;
                if (!src) return;
                var $repl = extract(src);
                if ($repl.length)
                    item.html = _.pluck(m.convertSources(extract(src).get(0).children), 'html').join('');
            });
        }


        if ((items.length)&&(items[items.length-1].type==='separator'))
            items.pop();

        return items;
    };
    menu.prototype.convertSources = function convertSources(nodes) {
        var items = [],
            m = this,
            contextualize = m.queryContext,
            prevsep = false;

        _.each(nodes, function(node) {
            var query = $(node).data('query'),
                res = {};

            if ((query)&&(contextualize)&&!contextualize.call(m, query.action, query.options))
                return;

            switch (node.tagName.toLowerCase()) {
                case 'nps:group': case 'group':
                    res.type = 'group';
                    res.group = node.getAttribute('name');
                    res.html = _.pluck(m.convertSources(node.children), 'html').join('');
                break;
                case 'nps:element' : case 'element':
                    res.type = 'element';
                    res.html = m.makeElement(node);
                    prevsep = false;
                break;
                default:
                    if ((prevsep) || (!items.length)) return;
                    res.type = 'separator';
                    res.html = node.innerHTML;
                    prevsep = true;
                break;
            }

            items.push(res);
        });

        return items;
    };


    menu.prototype.makeElement = function makeElement(oSrc) {
        var act = oSrc.getAttribute("data-action"), html = oSrc.innerHTML;
        if (act) {
            return "<span class='ctItem ctAction "+oSrc.className+"' data-action='"+act+"'>"+html+"</span>";
        } else {
            return "<div class='ctItem "+oSrc.className+"'>"+html+"</div>";
        }
    };


    return {
        get: function (name, opts) {
            name = 'ctrl_'+name;
            opts = _.extend({}, opts, {el: name});
            return new menu(opts);
        }
    };

})(jQuery);

$(document).ready(function() {
    $('.trigger-siteslist').on('mouseover', function(e) {
        var oCtrl = NPSContext.get('sites');
        oCtrl.show({
            element: $(e.target),
            owner: window,
            position: {
                at: 'left bottom'
            }
        });
        return false;
    });
});